import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useParams, useLocation } from 'react-router-dom';
import api from 'services/api';
import {
  TextField,
  FormGroup,
  MenuItem,
  Grid,
  Tooltip,
  Button,
  DialogActions,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { setDisable } from 'redux/disable';
import AutocompleteParameters from 'components/AutocompleteParameters';
import Success from 'components/Snack/Success';
import Error from 'components/Snack/Error';
import HelpIcon from '@mui/icons-material/Help';
import { setLoading } from 'redux/loading';
import { MEASUREMENT_TYPES } from 'utils/consts';

function Form({
  setOpenPondModal, setOpenAutocomplete, setOpenLinearProgress, setForms, typeName,
}) {
  const location = useLocation();
  const [openProgress, setOpenProgress] = useState(false);
  const [parameters, setParameters] = useState([]);
  const [parametersWithType, setParametersWithType] = useState([]);
  const [initialParameters, setInitialParameters] = useState([]);
  let { id } = useParams();
  const dispatch = useDispatch();
  const error = Error();
  const success = Success();
  const parametersIsNull = useState(false);

  function newOptions(options) {
    formik.setFieldValue('parameters', options);
  }

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues(data);
  }

  async function request(data) {
    // envia os dados para api salvar no banco
    dispatch(setDisable(true));
    try {
      await api.post('/forms', { ...data }).then((resp) => {
        setOpenLinearProgress(false);
        setOpenPondModal(false);
        setOpenAutocomplete(true);
      });
      await api.get('/forms').then((resp) => setForms(resp.data));
      success();
    } catch (err) {
      error();
    } finally {
      dispatch(setDisable(false));
      dispatch(setLoading(false));
    }
  }

  // Criação dos campos e validação para o formulário
  const formik = useFormik({
    initialValues: {
      name: '',
      type: typeName || '',
      isActive: true,
      parameters: [],
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Campo Obrigatório'),
      isActive: Yup.string().required('Campo Obrigatório'),
      type: Yup.string().required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      if (values.parameters.length === 0) {
        setOpenLinearProgress(true);
        parametersIsNull[1](true);
        return true;
      }
      values.parameters = values.parameters.map((p) => ({
        parameter_id: p.id,
      }));
      request(values);
    },
  });

  useEffect(() => {
    async function loadData() {
      try {
        setOpenProgress(true);
        const parameter_ = await api.get('/parameters');

        setParameters(parameter_.data);
        setParametersWithType(
          parameter_.data.filter((parameter) => parameter.type === formik.values.type),
        );
      } catch (err) {

      }
      setOpenProgress(false);
    }
    loadData();
  }, []);

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
        formik.setFieldValue('id', null);
      } else if (location.state.data) {
        id = location.state.id;
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues(data);
    const tempParameters = [];
    if (data.parameters !== undefined) data.parameters.map((v) => tempParameters.push(v.parameter));
    formik.setValues({ ...data, parameters: tempParameters });
    setInitialParameters(
      tempParameters.map((v) => ({ parameter_id: v.id })),
    );
  }

  useEffect(() => {
    setParametersWithType(
      parameters.filter((parameter) => parameter.type === formik.values.type),
    );
  }, [formik.values.type, parameters]);

  // Estilização do tooltip
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  return (
    <div>
      <form
        style={{ padding: '1rem' }}
        onSubmit={formik.handleSubmit}
      >
        <Grid container spacing={2}>
          <Grid item xs={6} sm={12}>
            <FormGroup>
              <TextField
                InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                id="name"
                label={<div>Nome</div>}
                variant="outlined"
                name="name"
                type="text"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={!!(formik.touched.name && formik.errors.name)}
                helperText={
                  formik.touched.name
                  && formik.errors.name
                  && formik.errors.name
                }
              />
            </FormGroup>
          </Grid>
          <Grid item xs={6} sm={4}>
            <FormGroup>
              <TextField
                InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                id="isActive"
                select
                label={<div>Status</div>}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                variant="outlined"
                value={formik.values.isActive}
                name="isActive"
                // as="select"
                error={
                  !!(formik.touched.isActive && formik.errors.isActive)
                }
                helperText={
                  formik.touched.isActive
                  && formik.errors.isActive
                  && formik.errors.isActive
                }
              >
                <MenuItem key={1} value>
                  Ativo
                </MenuItem>
                <MenuItem key={2} value={false}>
                  Inativo
                </MenuItem>
              </TextField>
            </FormGroup>
          </Grid>
          <Grid item xs={6} sm={4}>
            <FormGroup>
              <FormGroup>
                <TextField
                  InputLabelProps={{ style: { pointerEvents: 'auto' } }}
                  id="type"
                  select
                  label={(
                    <div>
                      Tipo do Formulário
                      {' '}
                      <HtmlTooltip
                        title={(
                          <>
                            Tipo do formulário
                          </>
                        )}
                        placement="right"
                        arrow
                      >
                        <HelpIcon color="primary" fontSize="inherit" />
                      </HtmlTooltip>
                    </div>
                  )}
                  onChange={(e) => {
                    formik.setFieldValue('type', e.target.value);
                    formik.setFieldValue('parameters', []);
                  }}
                  onBlur={formik.handleBlur}
                  variant="outlined"
                  value={formik.values.type}
                  disabled={!!typeName}
                  name="type"
                  // as="select"
                  error={!!(formik.touched.type && formik.errors.type)}
                  helperText={
                    formik.touched.type
                    && formik.errors.type
                    && formik.errors.type
                  }
                >
                  {typeName
                    ? (
                      <MenuItem key={3} value={typeName}>
                        {MEASUREMENT_TYPES[typeName] || typeName}
                      </MenuItem>
                    )
                    : null}
                </TextField>
              </FormGroup>
            </FormGroup>
          </Grid>
          {/**
                 * Componente que lida com os parâmetros
                 */}
          {formik.values.parameters.length >= 0 && (
            <AutocompleteParameters
              type={typeName}
              disabled={formik.values.type === ''}
              form_id={id}
              parameters={formik.values.parameters}
              options={parametersWithType}
              callback={newOptions}
              parametersIsNull={parametersIsNull}
            />
          )}
        </Grid>

        <DialogActions style={{ marginTop: '1.5rem', padding: '0px' }}>
          <Button
            variant="outlined"
            onClick={() => setOpenPondModal(false)}
            disabled={formik.isSubmitting}
            style={{
              border: '1px solid red',
              color: 'red',
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={formik.handleSubmit}
            disabled={formik.isSubmitting}
            style={{
              backgroundColor: '#0267C1',
              color: 'white',
            }}
          >
            Adicionar
          </Button>
        </DialogActions>
      </form>
    </div>
  );
}

export default Form;
